import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'minmax(1px, 1fr) auto auto',
    gap: '0.25rem',
    fontSize: theme.size.sm
  },

  title: {
    display: 'flex',
    alignItems: 'center'
  },

  content: {
    width: '100%',
    color: theme.palette.textAlt
  },

  expand: {
    marginTop: '16px',
    color: '#8F8F8F',
    textDecoration: 'none'
  },

  closed: {
    textDecoration: 'line-through'
  }
}))

export default useStyles
